function setCookie(cname, cvalue, exdays) {
	if (exdays) {
		var d = new Date();
		d.setTime(d.getTime() + (exdays*24*60*60*1000));
		var expires = 'expires=' + d.toUTCString();
		document.cookie = cname + '=' + cvalue + '; ' + expires + '; path=/';
	} else {
		document.cookie = cname + '=' + cvalue + '; path=/';
	}
}

$('.cookie-notice__accept').on('click', function(event) {
	event.preventDefault();
	$('.cookie-notice').remove();
	setCookie('vbh_cn', 1, 364);
	setCookie('vbh_cn_sess', 1);
});
